const nodesType = {
    site: 'site',
    container: 'container',
    network: 'network',
    component: 'component',
};

export default Object.freeze(nodesType);
